/**
 * Fina · Favoritos (lista de deseos local)
 * Guarda handles de producto en localStorage. Sin login, para todos los visitantes.
 * API pública en window.FinaFavorites: all/count/has/add/remove/toggle/clear.
 * Emite el evento 'fina:favorites:change' cuando cambia la lista.
 */
(function () {
  const KEY = 'fina-favorites';

  function read() {
    try {
      const v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(
      new CustomEvent('fina:favorites:change', { detail: { list } })
    );
  }

  const API = {
    all: () => read(),
    count: () => read().length,
    has: (handle) => read().includes(handle),
    add: (handle) => {
      const l = read();
      if (handle && !l.includes(handle)) {
        l.push(handle);
        write(l);
      }
    },
    remove: (handle) => write(read().filter((h) => h !== handle)),
    toggle: (handle) => {
      const l = read();
      if (l.includes(handle)) {
        API.remove(handle);
        return false;
      }
      API.add(handle);
      return true;
    },
    clear: () => write([]),
  };

  window.FinaFavorites = API;

  function syncUI() {
    const n = API.count();
    document.querySelectorAll('[data-fina-fav-count]').forEach((el) => {
      const txt = n > 0 ? String(n) : '';
      // Solo mutar si cambia (evita bucles con el MutationObserver)
      if (el.textContent !== txt) el.textContent = txt;
      if (el.hidden !== (n === 0)) el.hidden = n === 0;
    });
    document.querySelectorAll('[data-fina-fav-toggle]').forEach((btn) => {
      const active = API.has(btn.getAttribute('data-fina-fav-toggle'));
      if (btn.classList.contains('is-active') !== active) {
        btn.classList.toggle('is-active', active);
      }
      const ap = active ? 'true' : 'false';
      if (btn.getAttribute('aria-pressed') !== ap) btn.setAttribute('aria-pressed', ap);
    });
  }

  // Toggle delegado: cualquier elemento con [data-fina-fav-toggle="handle"]
  // funcionará como botón de favorito (preparado para las tarjetas de producto).
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-fina-fav-toggle]');
    if (!btn) return;
    e.preventDefault();
    API.toggle(btn.getAttribute('data-fina-fav-toggle'));
  });

  document.addEventListener('fina:favorites:change', syncUI);
  document.addEventListener('DOMContentLoaded', syncUI);
  // Re-sincroniza cuando Shopify recarga secciones (filtros/paginación AJAX)
  document.addEventListener('shopify:section:load', syncUI);
  // Sincroniza entre pestañas
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) syncUI();
  });

  // Las rejillas de producto se re-renderizan por AJAX (filtros, paginación,
  // recomendaciones). Observamos el DOM y re-sincronizamos el estado del corazón.
  let debounce;
  function watch() {
    const obs = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(syncUI, 120);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) {
    watch();
  } else {
    document.addEventListener('DOMContentLoaded', watch);
  }

  syncUI();
})();
